import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Rating from '~/components/rating'
import Label from '~/truck/label'
import theme from '~/truck/theme'

const Container = styled.div`
  width: 100%;

  > :not(:last-child) {
    margin-bottom: ${theme.spacing.cozy}px;
  }

  ${up('lg')} {
    width: ${theme.spacing.cozy * 61}px;
  }
`

const Box = styled.div`
  align-items: center;
  display: flex;
  width: 100%;

  > :not(:last-child) {
    margin-right: ${theme.spacing.cozy}px;
  }
`

const ProgressWrapper = styled.div`
  position: relative;
  width: 100%;
`

const ProgressBorder = styled.div`
  border: 1px solid ${theme.colors.gray};
  border-radius: ${theme.spacing.compact}px;
  height: ${theme.spacing.cozy}px;
  width: 100%;
`

const Progress = styled.div<{ $color: string; $ratio: string }>`
  background: ${props => props.$color};
  border-radius: ${theme.spacing.compact}px;
  height: ${theme.spacing.cozy}px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: ${props => props.$ratio};
`

const getPercentageValue = (rate, total) => {
  const ratio = (rate / total) * 100

  return `${ratio}%`
}

const ReviewBar = props => {
  const { label, color, total, rate } = props

  const ratio = getPercentageValue(rate, total)

  return (
    <Box>
      <Label>{label}</Label>
      <Rating initialRating={1} stop={1} />
      <ProgressWrapper>
        <ProgressBorder />
        <Progress $color={color} $ratio={ratio} />
      </ProgressWrapper>
      <Label as="span" $textStyle="h5Semibold" style={{ width: 20 }}>
        {rate}
      </Label>
    </Box>
  )
}

const RatingGraph = props => {
  const { color, oneStar, twoStars, threeStars, fourStars, fiveStars, numOfReviews } = props

  return (
    <Container>
      <ReviewBar label={5} color={color} rate={fiveStars} total={numOfReviews} />
      <ReviewBar label={4} color={color} rate={fourStars} total={numOfReviews} />
      <ReviewBar label={3} color={color} rate={threeStars} total={numOfReviews} />
      <ReviewBar label={2} color={color} rate={twoStars} total={numOfReviews} />
      <ReviewBar label={1} color={color} rate={oneStar} total={numOfReviews} />
    </Container>
  )
}

export default RatingGraph
